import {FC, ReactNode} from "react";
import Button from "@memaro/components/Button.tsx";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({theme}) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 10,

    '.MuiSvgIcon-root': {
        fontSize: '3rem',
        color: theme.palette.text.secondary
    }
}))

export type AddSectionProps = {
    icon: ReactNode;
    label: string;
    onClick: () => void;
}

const AddSection: FC<AddSectionProps> = ({icon, label, onClick}) => {
    return (
        <StyledButton variant="contained" onClick={onClick}>
            {icon}
            <span>{label}</span>
        </StyledButton>
    )
}

export default AddSection
